import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, defineProps, defineEmits } from 'vue-demi';
import { VueRecaptcha } from 'vue-recaptcha';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormFieldRecaptcha',
  props: {
    value: null,
    error: { type: [String, Boolean] },
    config: null
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as {
  value: string;
  error: string | false;
  config?: {
    siteKey: string;
    theme?: string;
    size?: string;
  };
};





const recaptchaRef = ref<any>(null);

function onVerify(response: string) {
  emit('input', response);
}
function onExpired() {
  emit('input', '');
}
function onError() {
  emit('input', '');
}

watch(
  () => props.value,
  (val) => {
    if (!val && recaptchaRef.value) {
      recaptchaRef.value.reset();
    }
  },
);

return { __sfc: true,props, emit, recaptchaRef, onVerify, onExpired, onError, VueRecaptcha }
}

})